import { apiClient } from '@/lib/api/client'

const API_BASE = '/system-settings/app-versions'

export interface AppVersionListParams {
  search?: string
  per_page?: number
  page?: number
  [key: string]: unknown
}

export interface AppVersionPayload {
  application_id?: number
  version?: string
  build?: string
  min_supported_version?: string
  is_mandatory?: boolean
  rollout_percent?: number
  release_notes?: string
  download_url?: string
  checksum?: string
  published_at?: string | null
  [key: string]: unknown
}

export const AppVersionService = {
  async list(params?: AppVersionListParams) {
    const response = await apiClient.get(API_BASE, { params })
    return response.data
  },

  async get(id: number) {
    const response = await apiClient.get(`${API_BASE}/${id}`)
    return response.data
  },

  async create(payload: AppVersionPayload) {
    const response = await apiClient.post(API_BASE, payload)
    return response.data
  },

  async update(id: number, payload: AppVersionPayload) {
    const response = await apiClient.put(`${API_BASE}/${id}`, payload)
    return response.data
  },

  async remove(id: number) {
    const response = await apiClient.delete(`${API_BASE}/${id}`)
    return response.data
  },

  async restore(id: number) {
    const response = await apiClient.post(`${API_BASE}/${id}/restore`)
    return response.data
  },

  async bulkDelete(ids: number[], force = false) {
    const url = force ? `${API_BASE}/bulk/force-delete` : `${API_BASE}/bulk/delete`
    const response = await apiClient.post(url, { ids })
    return response.data
  },

  async bulkRestore(ids: number[]) {
    const response = await apiClient.post(`${API_BASE}/bulk/restore`, { ids })
    return response.data
  },
}
